var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87899F",
    fillRule: "evenodd",
    d: "M1.765.298a1.033 1.033 0 0 0-1.47.018 1.054 1.054 0 0 0 .018 1.481L6.106 7.5.313 13.203a1.054 1.054 0 0 0-.017 1.481 1.033 1.033 0 0 0 1.47.018l5.828-5.737 5.64 5.553c.411.404 1.07.396 1.47-.019a1.054 1.054 0 0 0-.017-1.48L9.082 7.5l5.605-5.518c.41-.404.418-1.067.017-1.482a1.033 1.033 0 0 0-1.47-.018l-5.64 5.553L1.765.298Z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseIcon;